import { API } from '@shared/types/api';
import { notNil } from '@shared/util/notNil';

// TODO(fant): i18n
export function toString(message: API.ChatMessageFragment): string {
  const users = message.meta?.users?.filter(notNil) ?? [];
  const userNames = users.map(u => u.username);

  if (message.subType === 'CHANNEL_CREATED') {
    return `${message.sender.username} created this group`;
  }

  if (message.subType === 'MESSAGE_DELETED' || message.subType === 'COMMENT_DELETED') {
    return 'Message removed by sender';
  }

  if (message.subType === 'USER_JOINED') {
    return `${message.sender.username} is on board!`;
  }

  if (message.subType === 'USERS_ADDED') {
    return `${userNames.join(', ')} added by ${message.sender.username}`;
  }

  if (message.subType === 'USER_REMOVED_FROM_CHANNEL') {
    return `${userNames.join(', ')} removed by ${message.sender.username}`;
  }

  if (message.subType === 'ME_REMOVED_FROM_CHANNEL') {
    const channelName = message.meta.channelName;
    const byUser = userNames[0];
    return `You've been removed from "${channelName}" by ${byUser}`;
  }

  if (message.subType === 'USER_NOTIFIED' || message.subType === 'USERS_TEXTED') {
    switch (userNames.length) {
      case 1:
        return 'Sent by SMS';
      case 2:
        return `Sent by SMS to ${userNames[0]}`;
      case 3:
        return `Sent by SMS to ${userNames[0]} and ${userNames[1]}`;
      case 4:
        return `Sent by SMS to ${userNames[0]}, ${userNames[1]} and ${userNames[2]}`;
      default:
        const numOther = userNames.length - 2; // 2 = number of directly mentioned names
        return `Sent by SMS to ${userNames[0]}, ${userNames[1]} and ${numOther} others`;
    }
  }

  if (message.subType?.startsWith('THREAD_') || message.subType?.startsWith('CARD_')) {
    return message.content;
  }

  return '';
}
